import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";

interface SharedDialogProps {
  message: string;
  heading?: string;
  onProceed?: () => void;
  dialogState: boolean;
  setDialogState: (value: boolean) => void;
  proceedButtonRequired: boolean;
  cancelOptionText?: string;
}
export const SharedDialog = ({
  dialogState,
  setDialogState,
  heading,
  message,
  cancelOptionText = "Cancel",
  proceedButtonRequired,
  onProceed,
}: SharedDialogProps) => {


  return (
    <Dialog
      open={dialogState}
      onClose={() => {
        setDialogState(false);
      }}
    >
      <DialogTitle>{heading}</DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        <DialogContentText>{message}</DialogContentText>
        <DialogActions>
          <Button
            size="small"
            onClick={() => {
              setDialogState(false);
            }}
          >
            {cancelOptionText}
          </Button>
          {proceedButtonRequired ? (
            <Button size="small" type="button" onClick={onProceed}>
              Proceed
            </Button>
          ) : (
            ""
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
